import styled from '@emotion/styled'

export const AddressFields = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-columns: auto 120px;
`

export const CityFields = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-columns: auto 120px;
`
